module.exports = __webpack_public_path__ + "img/left.78a2aa6b.svg";